import Router from "next/router";
import { useEffect } from "react";

export const navToPath = (path, as, action = "push") => Router[action](path, as);

export const gotoPath = (path, as, action) => () => navToPath(path, as, action);
export const reload = () => Router.replace(window.location.href);

export function usePreventBFCache() {
	useEffect(() => {
		const noop = () => {};
		window.addEventListener("unload", noop);
		return () => window.removeEventListener("unload", noop);
	}, []);
}
